import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CustomTabBar, { TabItem } from "../common-features/CustomTabBar";
import {
  Box,
  ButtonBase,
  Chip,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Snackbar,
  Alert,
  Tooltip
} from "@mui/material";
import Summary from "./Summary";
import { useNavigate } from "react-router-dom";
// import SanctionDetails from "./SanctionDetails";
// import ProcessingFee from "./ProcessingFee";
import ApplicationDetails from "./ApplicationDetails";
import LoanDocuments from "./LoanDocuments";
import DisbursementRequest from "./DisbursementRequest";
import ConnectWithSales from "./ConnectWithSales";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../services/redux/store";
import SummaryIcon from "../../assets/svgTabIcons/SummaryIcon";
import ApplicationDetailsIcon from "../../assets/svgTabIcons/ApplicationDetailsIcon";
// import SanctionDetailsIcon from "../../assets/svgTabIcons/SanctionDetailsIcon";
// import ProcessingFeeIcon from "../../assets/svgTabIcons/ProcessingFeeIcon";
import LoanDocumentsIcon from "../../assets/svgTabIcons/LoanDocumentsIcon";
import DisbursementRequestIcon from "../../assets/svgTabIcons/DisbursementRequestIcon";
import ConnectWithSalesIcon from "../../assets/svgTabIcons/ConnectWithSalesIcon";
import ChatIcon from "../../assets/svgIcons/message-circle-2.svg";
import disbursementRequestServices from "../../services/api/service/disbursementRequestService";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import {
  setExpenseDetailsDrf,
  setFeesDetails,
  setVasDetails,
} from "../../services/redux/slices/disbursementRequestSlice";
import { chatStatusConfig, setChatStatusConfig, setCurrentSessionId, setSalesUserId } from "../../services/redux/slices/chatSlice";
import { useTriggerData } from "../../hooks/useTriggerData";
import { setAdditionalSummaryActiveTab, setOpenFirstTimeOnlyPopup, setSummaryPageActiveTab } from "../../services/redux/slices/tabsSlice";
import { IconButton, PrimaryButtonSecond } from "../../components/ui/Button";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { updateFirstTimeViewOnlyPopupsFlags,fetchUserApplicationsFormData } from "../../services/api/service/userApplicationService";
import ConnectChatComponent from "../../components/ui/ConnectChatComponent";
import { authSelector } from "../../services/redux/slices/authSlice";
import chatServices from "../../services/api/service/chatService";
import { TruncatedTextWithTooltip } from "../../components/ui/TruncatedTextWithTooltip";
//import ConsentAuthorizationButton from "../../components/common/ConsentAuthorizationButton";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import { decrypt } from "../../utils/crypto";
import { mapCollateral,areAllVerificationsComplete, gotoPageStepOrLoanOverviewPage, isDeviceTypeMobile,checkVerificationStatus } from "../../utils/helpers";
import { validateCoApplicantFields } from  "../../components/ui/StepperDyanmicForm/helperDynamic";
import CrmIdChip from "../../components/crmChip";
import { 
    setHasCheckedInitialSummary,
    setIsEligibilityCheckSubmitted,
    setBreStatus,
    setLeadSequenceId,
    clearNotInList,
    setSavedBasicForCoApplicant,
    setDisableAddMoreCoApplicant,
    setAadhaarSeedingStatus,
    setActiveHorizontalIndex,
    setActiveVerticalIndex,
    setCollateralId,
    setreferenceOneId,
    setreferenceTwoId,
    setCompletedHorizontalIndex,
    setIsPanVerified,
    setLastVerifiedPhoneNumber,
    setLastVerifiedEmail,
    setIsMobileVerified,
    setIsEmailVerified,
    setCoApplicantVerification,
    setIsEligible,
    setNotInList, 
    setApplicationSource,
    setDisplayHorizontalSteps,
    setTrackingId,
    updateFormData,
    setFetchUserApplicationData
  } from "../../services/redux/slices/stepperDynamicFormSlice";
import { getFormJson } from "../../services/redux/thunks/stepperDynamicFormThunks";
import { extractCoApplicantKeysFromData, findLastFilledHorizontalStepIndex, handleClearData, handleInvokeLeadApiData, normalizeStepName, parseBooleanFlag, resolveAdditionalDetailsResumeVerticalIndex } from "./helper";
import { checkUndecided } from "../dashboard/ExistingApplication";
import { getGAExtendedJourneyPrefix } from "../../components/ui/StepperDyanmicForm/helper";
interface PopupUpdates {
  trackingId: string | number;
  SanctionedPopUp?: boolean;
  DisbursementPopUp?: boolean;
  ConnectWithSalesPopUp?: boolean;
}
interface ViewSummaryProps {
  // Props remain the same, but the component's internal rendering changes
  pageTypeSummary?: string;
}
const allTabs: TabItem[] = [
  {
    id: "summary",
    label: "Summary",
    icon: "",
    iconType: "svg",
    iconContent: <SummaryIcon />,
  },
  // {
  //   id: "appDetails",
  //   label: "Application Details",
  //   icon: "",
  //   iconType: "svg",
  //   iconContent: <ApplicationDetailsIcon />,
  // },
  // {
  //   id: "sanctionDetails",
  //   label: "Sanction Details",
  //   icon: "",
  //   iconType: "svg",
  //   iconContent: <SanctionDetailsIcon />,
  // }, TAB
  // {
  //   id: "processingFee",
  //   label: "Processing Fee and VAS",
  //   icon: "",
  //   iconType: "svg",
  //   iconContent: <ProcessingFeeIcon />,
  // },
  {
    id: "loanDocuments",
    label: "Loan Documents",
    icon: "",
    iconType: "svg",
    iconContent: <LoanDocumentsIcon />,
  },
  {
    id: "disbursementRequest",
    label: "Disbursement Request",
    icon: "",
    iconType: "svg",
    iconContent: <DisbursementRequestIcon />,
  },
  // {
  //   id: "connect",
  //   label: "Connect with sales",
  //   icon: "",
  //   iconType: "svg",
  //   iconContent: <ConnectWithSalesIcon />,
  // },
];

const ViewSummary: React.FC<ViewSummaryProps> = ({ pageTypeSummary="summary" }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const token: any = process.env.REACT_APP_FETCH_TOKEN;
  const { userProfile } = useSelector(authSelector);
  const applicationNumber = useSelector(
    (state: RootState) => state.stepper.trackingId
  );
  const applicationStatus = useSelector(
    (state: RootState) => state.tabs.applicationStatus
  );
  const summaryPageActiveTab =
    useSelector((state: RootState) => state.tabs.summaryPageActiveTab) ||
    "summary";
  const salesUserId = useSelector((state: RootState) => state.chat.salesUserId);
  const openFirstTimeOnlyPopup = useSelector(
    (state: RootState) => state.tabs.openFirstTimeOnlyPopup
  );
  const { fetchUserApplicationData } = useSelector(
    (state: RootState) => state.stepper
  );
  const { formData: formUserData } = useSelector(
    (state: RootState) => state.stepper
  );
  const breData = useSelector(
    (state: RootState) => state.stepper?.breData
  );
  const coApplicantDetails = useSelector(
    (state: RootState) => state.applicationLoanDetailsData.coApplicantDetails
  );
  const isAuthenticated = useSelector(authSelector)?.isAuthenticated;
  const { chatAccess, viewAccess } = useSelector(chatStatusConfig);
  const partnerStartedJourney = fetchUserApplicationData?.partnerStartedJourney || false;
  const { isTriggerDataEmpty, triggerData }: any = useTriggerData();
  const isApplicant = isTriggerDataEmpty ? true : triggerData?.toUser;
  const isSummaryRoute = location.pathname === "/application/summary";
  const shouldShowSummaryTabs = isApplicant || isSummaryRoute;
  const [tableLoading, setTableLoading] = useState(false);
  const [isSubmittingApplication, setIsSubmittingApplication] = useState(false);
  const [isSubmittinLoader, setIsSubmittingLoader] = useState(false);
  const [allDocumentsData, setAllDocumentsData] = useState<any[]>([]);
  const [applicants, setApplicants] = useState<string[]>(["Applicant"]);
  const baseTabsForFiltering = allTabs.filter((tab) => tab.id !== "connect");
  const chatRef = useRef<HTMLDivElement>(null);
  const connectButtonRef = useRef<HTMLButtonElement>(null);
  const [isChatConnectOpen, setIsChatConnectOpen] = useState(false);
  const [isContinueLoading, setIsContinueLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({
    open: false,
    message: "",
    severity: "error",
  });
  const [courseNameData, setCourseNameData] = useState<string>("");
  const reduxHorizontalSteps = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps
  );
  const { horizontalSteps, applicationSource } = useSelector((state: RootState) => state.stepper);
  const shouldHideChatForPwa = isXsOrSm;

  const extendedJourneyPrefix = useMemo(
      () => getGAExtendedJourneyPrefix(applicationSource),
      [applicationSource]
    );
  

  const getChatFeatureStatus = async (appNum: string) => {
    try {
      const res = await chatServices.getChatFeatureStatus({
        applicationId: appNum
      });

      const responseData = res.data?.data;
      if (responseData) {
        dispatch(setChatStatusConfig({
          chatAccess: responseData.chatAccess,
          viewAccess: responseData.viewAccess,
          loading: false
        }));
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (applicationNumber && location.pathname != "/apply-now") {
      getChatFeatureStatus(applicationNumber);
    }
  }, [applicationNumber]);

  const showFirstTimeViewOnlyModalsAndUpdateStatus = useCallback(async () => {
    if (!applicationNumber || !token) {
      return;
    } else {
      const updates: Partial<PopupUpdates> = {
        trackingId: applicationNumber,
      };

      let popupPayload = null;
      let shouldUpdateFlags = false;

      // Loan Status
      // if (
      //   applicationStatus?.toLowerCase() === "sanctioned" &&
      //   openFirstTimeOnlyPopup.isSanctionedPopupViewed === false
      // ) {
      //   updates.SanctionedPopUp = true;
      //   popupPayload = {
      //     status: "info",
      //     message: "🎉Congratulations! Your loan has been sanctioned.",
      //   };
      //   shouldUpdateFlags = true;
      // } else 

      // if (
      //   applicationStatus?.toLowerCase() === "disbursed" &&
      //   openFirstTimeOnlyPopup.isDisbursedPopupViewed === false
      // ) {
      //   updates.DisbursementPopUp = true;
      //   popupPayload = {
      //     status: "info",
      //     message:
      //       "🎉Congratulations! Your loan has been disbursed. Check your email for complete details.",
      //   };
      //   shouldUpdateFlags = true;
      // }

      // Chat Logic
      // if (
      //   salesUserId &&
      //   openFirstTimeOnlyPopup.isConnectWithSalesPopupViewed === false
      // ) {
      //   updates.ConnectWithSalesPopUp = true;
      //   shouldUpdateFlags = true;

      //   setSnackbar({
      //     open: true,
      //     message:
      //       "Chat option is now enabled! Connect with our support team instantly for any assistance.",
      //     severity: "success",
      //   });
      // }

      if (shouldUpdateFlags) {
        if (popupPayload) {
          dispatch(setStatusPopup(popupPayload));
        }

        try {
          await updateFirstTimeViewOnlyPopupsFlags(
            token,
            applicationNumber,
            updates
          );
        } catch (error) {
          console.error("Failed to update popup flags:", error);
        }
      }
    }
  }, [
    applicationStatus,
    applicationNumber,
    token,
    salesUserId,
    openFirstTimeOnlyPopup,
    dispatch,
    setSnackbar,
  ]);

  useEffect(() => {
    showFirstTimeViewOnlyModalsAndUpdateStatus();
  }, [openFirstTimeOnlyPopup, salesUserId, applicationStatus]);

  // Build applicants list from coApplicantDetails
  useEffect(() => {
    const applicantsList: string[] = ["Applicant"];
    if (coApplicantDetails && typeof coApplicantDetails === "object") {
      const coApplicantKeys = Object.keys(coApplicantDetails);
      const sortedKeys = coApplicantKeys.sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, "")) || 0;
        const numB = parseInt(b.replace(/\D/g, "")) || 0;
        return numA - numB;
      });
      sortedKeys.forEach((key, index) => {
        const match = key.match(/coapplicant(\d+)/i);
        if (match) {
          const num = match[1];
          applicantsList.push(`Co-Applicant ${num}`);
        }
      });
    }
    setApplicants(applicantsList);
  }, [coApplicantDetails]);

  // DYNAMIC TAB FILTERING LOGIC
  const filteredTabs = baseTabsForFiltering.filter((tab) => {
    switch (applicationStatus?.toLowerCase()) {
      case "submit_to_cpa":
        if (
          tab.id === "loanDocuments" ||
          tab.id === "disbursementRequest"
        ) {
          return false;
        }
        break;

      case "sanctioned":
        if (tab.id === "sanctionDetails") {
          return false;
        }
        break;

      case "disbursed":
        // All tabs are visible
        break;

      default:
        if (
          // tab.id === "sanctionDetails" ||
          // tab.id === "processingFee" ||
          tab.id === "loanDocuments" ||
          tab.id === "disbursementRequest"
        ) {
          return false;
        }
        break;
    }
    return true;
  });

  const connectWithSalesTab: TabItem = allTabs.find(
    (tab) => tab.id === "connect"
  )!;

  // Final visible tabs array for the CustomTabBar
  // Includes filtered tabs and adds 'Connect with sales' only on small screens if salesUserId exists
  let  originalArray = [
    ...filteredTabs,
    ...(isXsOrSm && salesUserId && connectWithSalesTab
      ? [connectWithSalesTab]
      : []),
  ];
  const visibleTabs : TabItem[]= pageTypeSummary==="loansummary" ? originalArray.map((item, index) => {
    // Check if it's the 0th index AND the label is "Summary"
    if (index === 0 && item.label === "Summary") {
      return {
        ...item,
        label: "Loan Application Overview", // Put your new name/label here
        // You can also change other properties here if needed, like:
        // id: "new-summary-id" 
      };
    }
    return item; // Leave other items unchanged
  }): [
    ...filteredTabs,
    ...(isXsOrSm && salesUserId && connectWithSalesTab
      ? [connectWithSalesTab]
      : []),
  ];
  useEffect(() => {
    dispatch(setSummaryPageActiveTab("summary"));
  }, []);

  const handleTabChange = (tabId: string) => {
    dispatch(setSummaryPageActiveTab(tabId));

    // removing chat session id
    dispatch(setCurrentSessionId(""));
  };

  const handleSubmitForReview = () => { };

  // Robustly extract courseName with null checks
  useEffect(() => {
    let courseName: string;
    if (
      fetchUserApplicationData &&
      Array.isArray(fetchUserApplicationData.horizontalSteps) &&
      fetchUserApplicationData.horizontalSteps.length > 0 &&
      Array.isArray(fetchUserApplicationData.horizontalSteps[0]?.verticalSteps)
    ) {
      const courseStep =
        fetchUserApplicationData.horizontalSteps[0].verticalSteps.find(
          (step: any) =>
            step?.verticalStepName?.toLowerCase() === "provide course details"
        );
      if (courseStep && Array.isArray(courseStep.fields)) {
        const courseField = courseStep.fields.find(
          (field: any) => field.courseName
        );
        if (courseField && typeof courseField.courseName === "string") {
          courseName = courseField.courseName;
          setCourseNameData(courseName);
        }
      }
    }
  }, [fetchUserApplicationData])


  const getDisbursementRequestDetails = async () => {
    if (summaryPageActiveTab === "disbursementRequest") {
      setTableLoading(true);
      try {
        const res =
          await disbursementRequestServices.getDisbursementRequestDetails(
            fetchUserApplicationData?.applicationId
          );
        if (res && res.data && res.data.data) {
          dispatch(setExpenseDetailsDrf(res.data.data.ExpenseDetails || []));
          dispatch(setFeesDetails(res.data.data.FeesDetails || []));
          dispatch(setVasDetails(res.data.data.VASDetails || []));
        }
      } catch (e) {
        // Optionally handle error
        dispatch(setExpenseDetailsDrf([]));
        dispatch(setFeesDetails([]));
        dispatch(setVasDetails([]));
      } finally {
        setTableLoading(false);
      }
    }
  };

  useEffect(() => {
    if (summaryPageActiveTab === "disbursementRequest") {
      getDisbursementRequestDetails();
    }
  }, [summaryPageActiveTab]);
 const examNames = Object.keys(formUserData)
  .filter((key) => {
    if (!/^(languageExamName|coreExamName)(_\d+)?$/.test(key)) {
      return false;
    }

    const suffix = key.match(/(_\d+)?$/)?.[0] || "";

    const scoreExpectedKey = key.startsWith("languageExamName")
      ? `languageScoreExpectedOn${suffix}`
      : `coreScoreExpectedOn${suffix}`;

    return formUserData[scoreExpectedKey as keyof typeof formUserData] == "";
  })
  .map((key) => formUserData[key as keyof typeof formUserData])
  .filter(Boolean);
  let collateralTypeData=mapCollateral().filter((item:any)=>item.value === formUserData?.collateralType)?.[0]?.label || ""
     
  /**
   * Fetches mandatory documents for all applicants and co-applicants
   */
  const fetchMandatoryDocuments = async () => {
    try {
      const allDocsData: any[] = [];

      // Determine the list of applicants
      const applicantsList = applicants && applicants.length > 0 ? applicants : ["Applicant"];

      // Helper function to format applicant type
      const formatApplicantType = (value: string) => {
        return value
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, (m) => m.toUpperCase())
          .replace(/Co Applicant/i, "Co-Applicant");
      };
      // Fetch documents for each applicant/co-applicant
      for (let i = 0; i < applicantsList.length; i++) {
        const coApplicantDetail = i > 0
          ? coApplicantDetails?.[`coapplicant${i}` as keyof typeof coApplicantDetails] as any
          : null;
        let coappnum=applicantsList[i].split(" ")[1] || "0";
          const coAppEmpType = formUserData?.[`employmentCoApplicant${coappnum}employmentType`];
          const payload: any = partnerStartedJourney
          ? {
            applicationId: fetchUserApplicationData?.applicationId,
            applicantId:
              i === 0
                ? fetchUserApplicationData?.applicantId
                : String(coApplicantDetail?.coApplicantId ?? ""),
            trackingId: String(applicationNumber ?? ""),
            ...(i === 0 && {
                isCollateral:
                  formUserData?.collateral || "No",
                isAppliedEntranceExam:
                  formUserData?.coreExamApplied==="Yes" || 
                  formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
                collateralType: collateralTypeData?.toLowerCase(),
                entranceExamNames: examNames,
              }),
            applicantType: i === 0 ? "Applicant" : formatApplicantType(
              String(coApplicantDetail?.coApplicantType ?? "")
            ),
          }
          : {
            productType: formUserData?.product,
            typeOfApplicant: i === 0 ? "Applicant" : applicantsList[i],
            productCategory: formUserData?.courseCategory,
            typeOfIndividual: "Individual",
            employmentCategory: i === 0 ? formUserData?.employmentType|| formUserData?.applicantType : coAppEmpType || "student",
            trackingId: applicationNumber,
            ...(i === 0 && {
                isCollateral:
                  formUserData?.collateral || "No",
                isAppliedEntranceExam:
                  formUserData?.coreExamApplied==="Yes" || 
                  formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
                collateralType:  collateralTypeData?.toLowerCase(),
                entranceExamNames: examNames,
              }),
          };
        let response;
        if (partnerStartedJourney === true) {
          const hasValidIds =
            Boolean(payload.applicationId) && Boolean(payload.applicantId);
          if (!hasValidIds) continue;
          response = await eligibilityCheckServices.getDocuments(payload);
        } else {
          if (payload?.typeOfApplicant) {
            response = await eligibilityCheckServices.getMandatoryDocuments(payload);
          }
        }

        if (response?.status === 200) {
          allDocsData.push({
            applicantIndex: i,
            applicantType: i === 0 ? "Applicant" : `Co-Applicant ${i}`,
            documents: response?.data?.data || [],
          });
        }
      }

      setAllDocumentsData(allDocsData);
      return allDocsData;
    } catch (error) {
      console.error("Error fetching mandatory documents:", error);
      return [];
    }
  };

  /**
   * Checks if all mandatory documents are uploaded for all applicants
   */
  const checkAllMandatoryDocumentsUploaded = (allDocsData: any[]) => {
    const missingDocuments: any[] = [];
    allDocsData.forEach((applicantData: any) => {
      applicantData.documents.forEach((category: any) => {
        
        const mandatoryDocsOne = category?.documents?.filter(
          (doc: any) => (doc?.docNameDms !== "offer_letter" && doc?.isMandatory === true) || (doc?.isMandatory === true  && (formUserData?.admissionStatus?.toLowerCase() === "confirmed"))
        );
        const admissionStatus = formUserData?.admissionStatus?.toLowerCase();
        const isConfirmed = admissionStatus === "confirmed";

        // mandatoryDocs will be an ARRAY of filtered document objects
        const mandatoryDocs = category?.documents?.filter((doc: any) => {
          const docName = doc?.docName;
          const docNameDms = doc?.docNameDms;

          // --- 1. Tab > 0 Logic (Co-Applicants) ---
          if (doc?.typeOfApplicant !== "Applicant") {
            if (
              category?.name === "Academic Documents" ||
              category?.name === "Entrance Exam Documents" ||
              category?.name === "Proof of Admission"
            ) {
              doc.isMand = false;
            }

            // Passport is non-mandatory
            if (docNameDms === "passport") {
              doc.isMandatory = false;
              doc.byDefault = false;
              return false; // Exclude from array
            }
            const match = doc?.typeOfApplicant?.match(/\d+/);
            const findApplicantIndex = match ? parseInt(match[0], 10) : null;
            const coAppEmpType = formUserData?.[`employmentCoApplicant${findApplicantIndex}employmentType`];
            const basicCoAppPayParty = formUserData?.[`basicCoApplicant${findApplicantIndex}PayParty`];
            // Bank Statement Check
            const isBankStatement = docName?.includes("Bank Statement") || docNameDms === "account_statement";
            if (basicCoAppPayParty === "Yes" && isBankStatement) {
              doc.byDefault = true;
              doc.isMandatory = true;
              return true; // Include in array
            }

            // Offer Letter Check
            if (docNameDms === "offer_letter" && (admissionStatus === "undecided" || admissionStatus === "applied")) {
              doc.isMandatory = false;
              doc.byDefault = true;
              return false; // Exclude from array
            }

            // Employment-based checks
            let isMatch = false;
            if (coAppEmpType === "Salaried") {
              isMatch = docName?.includes("Salary Slips") || docNameDms === "salary_slip";
            } else if (coAppEmpType === "SENP") {
              isMatch = docName?.includes("ITR") || docNameDms === "itr" || docName?.includes("GST") || docNameDms === "business_proof";
            } else if (coAppEmpType === "SEP") {
              isMatch = docName?.includes("ITR") || docNameDms === "itr";
            } else if (coAppEmpType === "Farmer" || coAppEmpType === "Others") {
              isMatch = isBankStatement &&  basicCoAppPayParty=="Yes"?true:false;
            }

            if (isMatch) {
              doc.byDefault = true;
              doc.isMandatory = basicCoAppPayParty=="Yes"?true:false;
              return basicCoAppPayParty; // Include only if mandatory
            }
          }

          // --- 2. Tab === 0 Logic (Primary Applicant) ---
          if (doc?.typeOfApplicant === "Applicant") {
            // Offer Letter Check
            if (docNameDms === "offer_letter" && (admissionStatus === "undecided" || admissionStatus === "applied")) {
              doc.isMandatory = false;
              doc.byDefault = false;
              return false; // Exclude from array
            }

            // I-20 Check
            if(formUserData?.admissionStatus?.toLowerCase()==="confirmed" && doc?.docName === "I-20"){
              doc.isMandatory = false;
              doc.byDefault = true;
            }

            const empType = formUserData?.employmentType;

            let isMatch = false;
            let isMandatoryOverride = false;

            if (empType === "Salaried" && docNameDms === "salary_slip") {
              isMatch = docName?.includes("Salary Slips") || docNameDms === "salary_slip";
              isMandatoryOverride = true;
            } else if (["Salaried", "SEP", "SENP", "Others", "Farmer"].includes(empType) && docName === "Bank Statement") {
              isMatch = true;
              isMandatoryOverride = true;
            } else if (empType === "SENP" && (docNameDms === "salary_slip" || docNameDms === "business_proof")) {
              isMatch = true;
              isMandatoryOverride = true;
            } else if (empType === "SEP" && docNameDms === "salary_slip") {
              isMatch = docName?.includes("Proof of Income (Salary Slips/ITR)") || docNameDms === "salary_slip";
              isMandatoryOverride = true;
            } else if (empType === "Farmer" || empType === "Others") {
              isMatch = docName?.includes("Bank Statement") || docNameDms === "account_statement";
              isMandatoryOverride = true;
            }

            if (isMatch) {
              doc.byDefault = true;
              doc.isMandatory = isMandatoryOverride;
              return isMandatoryOverride; // Include only if mandatory
            }
          }

          // --- 3. Default Mandatory Fallback ---
          const isMandatory = (docNameDms !== "offer_letter" && doc?.isMandatory === true) || 
                              (doc?.isMandatory === true && isConfirmed);

          return isMandatory; // True includes the doc in mandatoryDocs array, false excludes it
        }) || [];
        
        mandatoryDocs?.forEach((doc: any) => {
          if ((!doc?.userDocs || doc?.userDocs?.length === 0) && doc?.isMandatory===true) {
            missingDocuments.push({
              applicantType: applicantData.applicantType,
              categoryName: category.name,
              docName: doc.docName,
            });
          }
        });
      });
    });
    return {
      allUploaded: missingDocuments.length === 0,
      missingDocuments,
    };
  };

  /**
   * Checks if all co-applicants have completed their details
   */
  const checkCoApplicantsCompletion = () => {
    if (!coApplicantDetails || typeof coApplicantDetails !== "object") {
      return { allCompleted: true, incompleteApplicants: [] };
    }

    const incompleteApplicants: string[] = [];
    const coApplicantKeys = Object.keys(coApplicantDetails);

    coApplicantKeys.forEach((key) => {
      const match = key.match(/coapplicant(\d+)/i);
      if (match) {
        const num = match[1];
        const coApplicant = coApplicantDetails[key];

        // Check if co-applicant has essential details filled
        // Adjust these fields based on your required fields
        const hasFirstName = coApplicant?.FirstName || coApplicant?.firstName;
        const hasLastName = coApplicant?.LastName || coApplicant?.lastName;
        const hasEmail = coApplicant?.Email || coApplicant?.email;
        const hasPhone = coApplicant?.PhoneNumber || coApplicant?.phoneNumber || coApplicant?.phone;

        if (!hasFirstName || !hasLastName || !hasEmail || !hasPhone) {
          incompleteApplicants.push(`Co-Applicant ${num}`);
        }
      }
    });

    return {
      allCompleted: incompleteApplicants.length === 0,
      incompleteApplicants,
    };
  };

  const checkMinimumTwoCoApps = (): boolean => {
    if(Object.keys(coApplicantDetails || {}).length >= 2) {
      return true;
    }
    return false;
  }

  /**
   * Handles the Submit Application button click
   */
  const handleSubmitApplication = async () => {
    let submittingApplication = true

    let errorMessage = ""
    try {
      //setIsSubmittingApplication(true);

      // Check if application form is fully completed (horizontalSteps[1].completionRate === 100)
      // if (
      //   fetchUserApplicationData?.isProvisionalGenerated === false
      // ) {
      //   setSnackbar({
      //     open: true,
      //     message: `Oops! It looks like We are missing some details. Please fill in all required details and upload the mandatory documents to submit your application.`,
      //     severity: "error",
      //   });
      //   setIsSubmittingApplication(false);
      //   return;
      // }
      setIsSubmittingLoader(true);
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const applicationId = fetchUserApplicationData?.submissionId;
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationId
      );
      //Fetch mandatory documents for all applicants
      const {status,count}=validateCoApplicantFields(res?.data?.applications[0]);
      if(status===false){
        if (errorMessage != "") errorMessage += "\n"
        errorMessage+="Please complete all required data fields in the application before submitting.";
        setIsSubmittingApplication((prev)=>false);
        submittingApplication = false
         // show error  message
      }
      if(count<2){
        if (errorMessage != "") errorMessage += "\n"
        errorMessage+="Please add atleast 2 co-applicants to proceed with your application.";
        // show error  message
         setIsSubmittingApplication((prev)=>false);
         submittingApplication = false
      }
      const allDocsData = await fetchMandatoryDocuments();
      let getFormUserData=res?.data?.applications[0];
      const targetHorizontal =getFormUserData?.horizontalSteps.find(
        (hStep:any) => hStep.horizontalStepName === "Applicant & Loan Details"
      );

      // 2. Target vertical step search karke fields fetch karna
      const coApplicantFields = targetHorizontal
        ?.verticalSteps
        ?.find((vStep:any) => vStep.verticalStepName === "Co-Applicant Details")
        ?.fields || [];
        
      // Check if all mandatory documents are uploaded
      const { allUploaded, missingDocuments } = checkAllMandatoryDocumentsUploaded(allDocsData);
      if (!allUploaded || allDocsData.length === 0) {

        if (errorMessage!="") errorMessage += "\n"
        errorMessage += "Please upload all the mandatory documents for submitting the application."

        setIsSubmittingApplication((prev)=> false);
        submittingApplication = false
        // return;
      }
      const consentValid=checkVerificationStatus(res?.data?.applications[0]);
      if(consentValid===false){
        if (errorMessage!="") errorMessage += "\n"
        errorMessage += "Please verify all the email and mobile number for submitting the application."
        setIsSubmittingApplication((prev)=>false);
        submittingApplication = false
        // return;
      }
      const identityValid=checkVerificationStatus(res?.data?.applications[0], true);
      
      if(identityValid===false){
        if (errorMessage!="") errorMessage += "\n"
        errorMessage += "Application submission failed: PAN/Aadhaar identity verification is incomplete for the Applicant or a Co-Applicant. Please verify PAN and Aadhaar for all applicants to continue."
        setIsSubmittingApplication((prev)=>false);
        submittingApplication = false
      }

      // if (!isSubmittingApplication) {
      if (!submittingApplication) {
        setIsSubmittingLoader(false);
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
        return;
      }
      
      // All mandatory documents are uploaded, proceed with submission
      // Call the update application status API
      const response = await eligibilityCheckServices.updateApplicationStatus(
        applicationNumber,
        { status: "Application Submitted" }
      );

      if (response?.status === 200) {
        setIsSubmittingLoader(false);
        // Show success message
        setSnackbar({
          open: true,
          message: "Application submitted successfully!",
          severity: "success",
        });

        trackCustomerJourneyEvent(
          `${extendedJourneyPrefix}_SUBMIT_APPLICATION_PAGE18`,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: `${extendedJourneyPrefix}_SUBMIT_APPLICATION_PAGE18`,
            category: `${extendedJourneyPrefix}_SUBMIT_APPLICATION_PAGE18`,
            action: `${extendedJourneyPrefix}_SUBMIT_APPLICATION_PAGE18`,
            page: "Extended Journey_loan application overview_SubmitApplication",
          }
        );

        // Reload the page to fetch updated data
        setTimeout(() => {
          navigate("/application/existing-application");
        }, 1500);
      }

    } catch (error: any) {
      console.log(error,"error")
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to submit application. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSubmittingApplication(false);
      setIsSubmittingLoader(false);
      submittingApplication = false;
    }
  };

  /**
   * Checks if the Submit Application button should be visible
   */
  const shouldShowSubmitButton = () => {
    return isApplicant && applicationStatus !== "Application Submitted" && partnerStartedJourney !== true;
  };

  // chat window open/close functions
  const handleChatConnectOpen = () => {
    if (shouldHideChatForPwa) {
      setIsChatConnectOpen(false);
      return;
    }

    trackCustomerJourneyEvent(
      "CHAT_VIEW_SUMMARY",
      decrypt(userProfile?.id) ?? "",
      applicationNumber,
      {
        label: "CHAT_VIEW_SUMMARY",
        category: "CHAT_VIEW_SUMMARY",
        action: "CHAT_VIEW_SUMMARY",
        page: "Chat Option_View Summary",
      }
    );

    if (salesUserId) {
      setIsChatConnectOpen(true);
    }
  };
  const handleChatConnectClose = () => setIsChatConnectOpen(false);

  const handleTriggerConsentAuthorization = ({ type }: { type: "applicant" | "coapplicant" }) => {
    // Add the consent mail API here; the button then opens the consent page.
    void type;
  };

  useEffect(() => {
    if (shouldHideChatForPwa && isChatConnectOpen) {
      setIsChatConnectOpen(false);
    }
  }, [shouldHideChatForPwa, isChatConnectOpen]);

  // close chat window on outside click
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        isChatConnectOpen &&
        chatRef.current &&
        !chatRef.current.contains(event.target) &&
        !connectButtonRef.current?.contains(event.target)
      ) {
        handleChatConnectClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isChatConnectOpen]);

  // prevent body scroll when chat is open
  useEffect(() => {
    if (isChatConnectOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    };
  }, [isChatConnectOpen]);

   const handleContinue = async (e:any) => {
      e.preventDefault();
      dispatch(setHasCheckedInitialSummary(false));
      dispatch(setAdditionalSummaryActiveTab(0));
      if (fetchUserApplicationData?.assistedJourneyRequired) {
        dispatch(
          setStatusPopup({
            status: "info",
            message:
              "You have already started your journey with a partner. Please complete your journey with the partner.",
          })
        );
        return;
      } else {
        setIsContinueLoading(true);
        try {
          dispatch(setIsEligibilityCheckSubmitted(false));
          handleClearData(dispatch);
          const breObj = breData;
          // Consider blank if all values are empty string, null, or undefined
          const isBlankObject =
            breObj &&
            Object.keys(breObj).length > 0 &&
            Object.values(breObj).every(
              (v) => v === "" || v === null || v === undefined
            );
  
          if (isBlankObject) {
            dispatch(setBreStatus("FROM_FORM"));
          } else {
            dispatch(setBreStatus("FROM_APPLICATION"));
          }
          try {
            const token: any = process.env.REACT_APP_FETCH_TOKEN;
            const applicationId = applicationNumber;
            await dispatch(getFormJson({ product: "SLI", trackingId: applicationId }));
            const res: any = await fetchUserApplicationsFormData(
              token,
              applicationId
            );
            const apps = res.data?.applications || [];

            // Sync the freshly-fetched application into fetchUserApplicationData so
            // isDIYJourney (partnerStartedJourney-derived) reflects THIS application
            // instead of whatever was left over from a previously viewed one.
            if (apps?.[0]) {
              dispatch(setFetchUserApplicationData(apps[0]));
            }

            dispatch(setLeadSequenceId(apps?.[0]?.leadId || ""));
            const applicationSource = apps?.[0]?.source || "";
  
  
            const verticalSteps = apps?.[0]?.horizontalSteps?.[0]?.verticalSteps;
            const filterCourseData = Array.isArray(verticalSteps)
              ? verticalSteps.find((elem: any) => elem?.verticalStepName === "Provide Course Details")
              : undefined;
  
            if (filterCourseData) {
              // Sync notInList to Redux from fetched course-details (universityNotInList, instituteNotInList, courseNameNotInList)
              const fields = filterCourseData?.fields || [];
              const getFieldValue = (key: string) => {
                const obj = fields.find((f: any) => f && key in f);
                return obj ? String(obj[key]).toLowerCase() : "";
              };
              dispatch(clearNotInList());
              if (getFieldValue("universityNotInList") === "true") dispatch(setNotInList("University Name"));
              if (getFieldValue("instituteNotInList") === "true") dispatch(setNotInList("Institute Name"));
              if (getFieldValue("courseNameNotInList") === "true") dispatch(setNotInList("Course Name"));
            }
  
            // Prefer fetched application data to drive first-time correctness
            const fetchedApplicantLoanStep = apps?.[0]?.horizontalSteps?.find(
              (step: any) =>
                step.horizontalStepName === "Applicant & Loan Details"
            );
  
            const fetchedLoanDetailsStep = fetchedApplicantLoanStep?.verticalSteps?.find(
              (vStep: any) => vStep.verticalStepName === "Co-Applicant Details"
            );
  
            if (fetchedLoanDetailsStep?.fields) {
              // 1) Mark co-applicant basics as saved based on fetched data
              const coApplicantKeysFromData = extractCoApplicantKeysFromData(
                fetchedLoanDetailsStep.fields || [],
              );
              coApplicantKeysFromData.forEach((coAppKey) => {
                dispatch(
                  setSavedBasicForCoApplicant({
                    coAppKey,
                    value: true,
                  }),
                );
              });
  
              // 2) Build fetched isEmployed keys set
              const fetchedIsEmployedFields = new Set<string>();
              fetchedLoanDetailsStep.fields.forEach((field: any) => {
                Object.keys(field || {}).forEach((key) => {
                  if (
                    /^employmentCoApplicant\d+isEmployed$/.test(key) &&
                    field[key] &&
                    field[key] !== ""
                  ) {
                    fetchedIsEmployedFields.add(key);
                  }
                });
              });
  
              // 3) If Redux schema is available, compare and potentially disable add more
              if (reduxHorizontalSteps && Array.isArray(reduxHorizontalSteps)) {
                const reduxApplicantLoanStep = reduxHorizontalSteps.find(
                  (step: any) => step.stepLabel === "Applicant & Loan Details",
                );
                const reduxLoanDetailsStep =
                  reduxApplicantLoanStep?.verticalSteps?.find(
                    (vStep: any) => vStep.stepLabel === "Co-Applicant Details",
                  );
                const reduxIsEmployedFields = (reduxLoanDetailsStep?.fields || [])
                  .map((field: any) => field.name)
                  .filter((name: string) =>
                    /^employmentCoApplicant\d+isEmployed$/.test(name),
                  );
  
                if (reduxIsEmployedFields.length > 0) {
                  const missingFields = reduxIsEmployedFields.filter(
                    (fieldName: string) =>
                      !fetchedIsEmployedFields.has(fieldName),
                  );
                  if (missingFields.length > 0) {
                    dispatch(setDisableAddMoreCoApplicant(true));
                  }
                }
              }
            }
  
            dispatch(setApplicationSource(apps?.[0]?.source || ""));
  
            handleInvokeLeadApiData(apps?.[0], dispatch);
            dispatch(setAadhaarSeedingStatus(apps?.[0]?.isAadhaarSeeded));
  
            // setting firsttime view only popup flags which will get displayed in summary page
            dispatch(
              setOpenFirstTimeOnlyPopup({
                isSanctionedPopupViewed: apps[0]?.SanctionedPopUp,
                isDisbursedPopupViewed: apps[0]?.DisbursementPopUp,
                isConnectWithSalesPopupViewed: apps[0]?.ConnectWithSalesPopUp,
              })
            );
  
            // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
            dispatch(setSalesUserId(res?.data?.applications?.[0]?.assignedSMId));
  
            // Clear display horizontal steps before setting new data
            dispatch(setDisplayHorizontalSteps([]));
  
            // Add small delay to ensure clearing is processed before setting new data
            await new Promise(resolve => setTimeout(resolve, 50));
  
            // this logic is for getting customized array of horizontalsteps
            let finalSteps: any[] = [];
            for (let i = 0; i < apps.length; i++) {
              const element = apps[i];
              //finalSteps = getCombinedApplicationSteps(element);
            }
            //dispatch(setDisplayHorizontalSteps(finalSteps));
            const data = filterCourseData?.fields?.find((f: any) => f.admissionStatus?.toLowerCase() === "undecided");
            const country = filterCourseData?.fields?.find((f: any) => f.country)?.country;
            const universityCountryId = filterCourseData?.fields?.find((f: any) => f.universityCountryId)?.universityCountryId;
            const isValid = checkUndecided(country, universityCountryId, applicationSource, apps?.[0]?.isQualified, apps[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.length);
  
            if (data && isValid) {
                dispatch(setActiveHorizontalIndex(0));
                dispatch(setActiveVerticalIndex(1));
            } else {
            if (
              apps?.[0] &&
              apps?.[0]?.isQualified === true &&
              apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length === 3 &&
              apps?.[0]?.horizontalSteps?.[1].completionRate != 100 // if first two steps are 100% completed it means User shouldnt navigate to forms
            ) {
              const findVerticalStepLength = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 0 ? 0 :
                apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length - 1;
              const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
              const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(horizontalStepsData);
              const additionalDetailsIndex = horizontalStepsData.findIndex(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
              if (horizontalSteps[0]?.verticalSteps[1]?.fields?.length > apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length) {
                
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length - 2
                  )
                );
                dispatch(
                  setActiveHorizontalIndex(0)
                );
              } else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
                dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                dispatch(
                  setActiveVerticalIndex(
                    resolveAdditionalDetailsResumeVerticalIndex(
                      horizontalStepsData?.[additionalDetailsIndex],
                      horizontalStepsData
                    ),
                  ),
                );
              }
              else {
               
                if(apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length===2 && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
                ?.find((step:any) => step?.verticalStepName === "Co-Applicant Details") && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
                ?.find((step:any) => step?.verticalStepName === "Student Details")?.fields?.length === 4){
                  dispatch(setActiveHorizontalIndex(1));
                  dispatch(setActiveVerticalIndex(0));
  
                }else{
                  if(apps?.[0]?.isProvisionalGenerated===true){
                    dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                    dispatch(
                      setActiveVerticalIndex(
                        resolveAdditionalDetailsResumeVerticalIndex(
                          horizontalStepsData?.[additionalDetailsIndex],
                          horizontalStepsData
                        ),
                      ),
                    );
                  }else{
                    dispatch(setActiveHorizontalIndex(1));
                    dispatch(setActiveVerticalIndex(findVerticalStepLength));
                  }
                  
                }
  
              }
            } else {
              dispatch(setTrackingId(apps?.[0]?.submissionId || ""));
              dispatch(setCollateralId(apps?.[0]?.collateralId || null));
              dispatch(setreferenceOneId(apps?.[0]?.referenceOneId || null));
              dispatch(setreferenceTwoId(apps?.[0]?.referenceTwoId || null));
              const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
              const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(
                horizontalStepsData,
              );
              const additionalDetailsIndex = horizontalStepsData.findIndex(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
              
              const findActiveHorizontalIndex =
                apps?.[0]?.horizontalSteps?.filter(
                  (elem: any) => elem?.verticalSteps?.length > 0
                );
                if (horizontalSteps[0]?.verticalSteps[1]?.fields?.length > apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length) {
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length - 2
                  )
                );
                dispatch(
                  setActiveHorizontalIndex(0)
                );
              }else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
                dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                dispatch(
                  setActiveVerticalIndex(
                    resolveAdditionalDetailsResumeVerticalIndex(
                      horizontalStepsData?.[additionalDetailsIndex],
                      horizontalStepsData
                    ),
                  ),
                );
              }
              else if (
                additionalDetailsIndex !== -1 &&
                lastFilledHorizontalIndex > additionalDetailsIndex
              ) {
                // Application already progressed past Additional Details &
                // Documents (e.g. Summary/Loan Summary was already reached) —
                // resume at its last real step (Document & Consent) instead of
                // falling through to the stepper-index heuristics below, which
                // assume no step after Additional Details ever has data.
                dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                dispatch(setActiveVerticalIndex(4));
              }
              else if (apps?.[0]?.horizontalSteps?.[
                    findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.length <=  6 && apps?.[0]?.isProvisionalGenerated===true) {
                  
                  dispatch(setActiveHorizontalIndex(3));
                  dispatch(setActiveVerticalIndex(0));
                }
              else if (
                findActiveHorizontalIndex.length - 1 == 1 &&
                apps?.[0]?.horizontalSteps?.[findActiveHorizontalIndex.length - 1]
                  ?.verticalSteps?.length == 6
              ) {
                // Find the 'Loan Details' vertical step
                const loanDetailsStep = apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.find(
                  (step: any) => step.verticalStepName === "Co-Applicant Details"
                );
                // Check for LoanDetailsLoanAmount and collateral fields with values
                const hasLoanDetails =
                  loanDetailsStep &&
                  Array.isArray(loanDetailsStep.fields) &&
                  loanDetailsStep.fields.some(
                    (f: any) =>
                      f.LoanDetailsLoanAmount && f.LoanDetailsLoanAmount !== ""
                  ) &&
                  loanDetailsStep.fields.some(
                    (f: any) => f.collateral && f.collateral !== ""
                  );
  
                if (hasLoanDetails) {
                  // Dynamically check for any field key that includes 'basic', 'address', or 'employment'
                  const fieldKeyPatterns = ["basic", "address", "employment"];
                  const hasOtherFields = fieldKeyPatterns.every((pattern) =>
                    loanDetailsStep.fields.some((f: any) =>
                      Object.keys(f).some(
                        (key) =>
                          key.toLowerCase().includes(pattern) &&
                          f[key] &&
                          f[key] !== ""
                      )
                    )
                  );
  
                  if (!isBlankObject && hasOtherFields) {
                    dispatch(setActiveHorizontalIndex(3));
                    dispatch(setActiveVerticalIndex(0));
                  } else {
                    dispatch(setActiveHorizontalIndex(2));
                    dispatch(setActiveVerticalIndex(0));
                  }
                } else {
                  dispatch(
                    setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
                  );
                  dispatch(setActiveVerticalIndex(5));
                }
              } else {
                dispatch(
                  setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
                );
                if (findActiveHorizontalIndex.length === 1 && apps?.[0]?.isProvisionalGenerated===false) {
                  
                  dispatch(
                    setActiveVerticalIndex(
                      apps?.[0]?.horizontalSteps?.[
                        findActiveHorizontalIndex.length - 1
                      ]?.verticalSteps?.length
                    )
                  );
                  
  
                } else {
                  let filterveritical = apps?.[0]?.horizontalSteps?.[
                    findActiveHorizontalIndex.length - 1
                  ]?.verticalSteps?.find(
                    (step: any) => step?.verticalStepName === "Co-Applicant Details"
                  );
                  const count = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.filter((item: any) => {
                    const value = Object.values(item)[0];
                    return value !== "" && value !== null && value !== undefined;
                  }).length;
                  // const isSingleVerticalStep = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 1;
                  const minimumCount =  13;
                
                  if (count < minimumCount)  {
                    dispatch(
                      setActiveVerticalIndex(0)
                    );
                  } else if (apps?.[0]?.horizontalSteps?.[
                    findActiveHorizontalIndex.length - 1
                  ]?.verticalSteps?.length <= 6 && apps?.[0]?.isProvisionalGenerated===true) {
                    
                      dispatch(setActiveHorizontalIndex(3));
                      dispatch(setActiveVerticalIndex(0));
                    
  
                  }else if (apps?.[0]?.horizontalSteps?.[
                    findActiveHorizontalIndex.length - 1
                  ]?.verticalSteps?.length != 6 && filterveritical?.verticalStepName === "Co-Applicant Details") {
                    dispatch(
                      setActiveVerticalIndex(
                        apps?.[0]?.horizontalSteps?.[
                          findActiveHorizontalIndex.length - 1
                        ]?.verticalSteps?.length - 1
                      )
                    );
  
                  }  else {
                    dispatch(
                      setActiveVerticalIndex(
                        apps?.[0]?.horizontalSteps?.[
                          findActiveHorizontalIndex.length - 1
                        ]?.verticalSteps?.length
                      )
                    );
  
                  }
  
                }
              }
              dispatch(
                setCompletedHorizontalIndex(findActiveHorizontalIndex.length - 1)
              );
            }
          }
  
            const lengthOfHorizontalSteps = apps?.[0]?.horizontalSteps?.length;
            let apiFormData: any = {};
            for (let i = 0; i < lengthOfHorizontalSteps; i++) {
              const verticalSteps =
                apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
              for (let j = 0; j < verticalSteps?.length; j++) {
                const fields = verticalSteps?.[j]?.fields;
                for (let k = 0; k < fields?.length; k++) {
                  const field = fields?.[k];
                  apiFormData = { ...apiFormData, ...field };
                }
              }
            }
            dispatch(setIsPanVerified(Boolean(apiFormData?.isPanVerified)));
            if (lengthOfHorizontalSteps >= 2) {
              dispatch(setIsEligibilityCheckSubmitted(true));
            }
            dispatch(setLastVerifiedPhoneNumber(apiFormData?.phone_number));
            dispatch(setLastVerifiedEmail(apiFormData?.email));
            dispatch(
              setIsMobileVerified(apiFormData?.phone_number ? true : false)
            );
            dispatch(setIsEmailVerified(apiFormData?.email ? true : false));
            dispatch(updateFormData(apiFormData));
            /**
             * Iterates over all fields in the fetched application form data.
             * For each co-applicant PAN, email, and phone field:
             *    - Extracts the co-applicant index and field type using regex.
             *    - Builds a verification object indicating whether each field is verified and stores the last verified value.
             *    - Dispatches the verification status to Redux for each co-applicant.
             * This ensures the UI can correctly display "Verified" status for each co-applicant's PAN, email, and phone fields.
             */
            Object.entries(apiFormData).forEach(([key, value]) => {
              const match = key.match(
                /^coApplicant(\d+)(PanNumber|Email|Phone_number)$/
              );
              if (match) {
                const idx = Number(match[1]) - 1; // usually index starts from 0
                const type = match[2];
                let verification: any = {};
                if (type === "PanNumber") {
                  verification.panVerified = !!value;
                  verification.lastPanNumber = value;
                }
                if (type === "Email") {
                  verification.emailVerified = !!value;
                  verification.lastVerifiedEmail = value;
                }
                if (type === "Phone_number") {
                  verification.mobileVerified = !!value;
                  verification.lastVerifiedMobileNumber = value;
                }
                dispatch(
                  setCoApplicantVerification({
                    index: String(idx),
                    data: verification,
                  })
                );
              }
            });
            // Call checkOffer API if isQualified is false
            // if (apps?.[0] && apps?.[0]?.isQualified === false && apps?.[0]?.horizontalSteps[0]?.verticalSteps.length === 3 && apps?.[0]?.horizontalSteps[1]?.verticalSteps.length === 0) {
            //   // try {
            //   //   // const payload = {
            //   //   //   applicationId: apps?.[0]?.submissionId,
            //   //   //   name: "getCustomerEligibility",
            //   //   // };
  
            //   //   // const res: any = await eligibilityCheckServices.fetchBreApi(payload);
            //   //   // if (res?.data?.data?.Scheme_Available !== "Yes" && res?.data?.data?.Scheme_Available !== "No") {
            //   //     // const brePayload = {
            //   //     //   applicationId: apps?.[0]?.submissionId,
            //   //     //   provisionalOfferBody: {
            //   //     //     values: {
            //   //     //       input: {
            //   //     //         Unique_Lead_ID: apps?.[0]?.submissionId,
            //   //     //         oApplicant: {
            //   //     //           oApplName: {
            //   //     //             sFirstName: apiFormData?.firstName || "",
            //   //     //             sLastName: apiFormData?.lastName || "",
            //   //     //           },
            //   //     //           aCourseDetails: [
            //   //     //             {
            //   //     //               ...(apiFormData?.instituteNotInList === "false" && {
            //   //     //                 institute_code: apiFormData?.institute_code || "",
            //   //     //               }),
            //   //     //               ...(apiFormData?.courseNameNotInList === "false" && {
            //   //     //                 course_code: apiFormData?.courseCode || "",
            //   //     //               }),
            //   //     //               ...(apiFormData?.universityNotInList === "false" && {
            //   //     //                 university_campus_id:
            //   //     //                   apiFormData?.universityCampusId || "",
            //   //     //               }),
            //   //     //               category: apiFormData?.courseType || "",
            //   //     //               admission_status:
            //   //     //                 apiFormData?.admissionStatus || "",
            //   //     //               course_category: apiFormData?.courseCategory || "",
            //   //     //             },
            //   //     //           ],
            //   //     //         },
            //   //     //       },
            //   //     //     },
            //   //     //   },
            //   //     // };
  
            //   //     // const breResp = await eligibilityCheckServices.checkOffer(
            //   //     //   brePayload
            //   //     // );
            //   //   // }
            //   //   //dispatch(setBreData(breResp?.data?.data));
            //   // } catch (error) {
            //   //   console.error("CheckOffer API call failed:", error);
            //   //   dispatch(setIsEligible(false));
            //   // }
            // }
            dispatch(
              setIsMobileVerified(
                parseBooleanFlag(apiFormData?.isMobileVerified),
              ),
            );
            dispatch(
              setIsEmailVerified(parseBooleanFlag(apiFormData?.isEmailVerified)),
            );
            const isLoanOverview = await gotoPageStepOrLoanOverviewPage(applicationNumber);
            if(isLoanOverview) {
              navigate("/application/loan-summary");
            } else {
              navigate("/application/apply-now");
            }
            
          } catch (e) {
            console.log(e);
          }
        } catch (e) {
          console.log(e);
        } finally {
          setIsContinueLoading(false);
        }
      }
    };

  const submitReviewNotice = (
    <Box
      sx={{
        bgcolor: "#FFF8D6",
        border: "1px solid #F4D35E",
        borderRadius: "6px",
        p: 1.5,
        mt: 1,
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#8A6D00", mb: 0.5 }}>
        Before submission of application ensure:
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        <Typography component="li" sx={{ fontSize: "12.5px", color: "#8A6D00" }}>
          You review all the data and uploaded documents to ensure smooth processing of application.
        </Typography>
        <Typography component="li" sx={{ fontSize: "12.5px", color: "#8A6D00" }}>
          You are verifying the PAN for applicant and co-applicants.
        </Typography>
        <Typography component="li" sx={{ fontSize: "12.5px", color: "#8A6D00" }}>
          You are verifying the Mobile Number of Co-applicants.
        </Typography>
      </Box>
    </Box>
  );

  return (
    <div
      className="existing-application"
      style={{ minHeight: "auto !important", 
        marginTop: isDeviceTypeMobile(isXsOrSm) ? 20 : 0 
      }}
    >
      {isApplicant && !isXsOrSm && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
                my: 2,
              }}
            >
              
              {pageTypeSummary!="loansummary" && 
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ minWidth: 0, display: "flex", alignItems: "center", gap: '5px' }}>
                    <TruncatedTextWithTooltip
                      style={{ fontSize: "20px !important", fontWeight: 600, color: '#008688' }}
                      text={courseNameData || "-"}
                      limit={15}
                    />
                    <Typography
                      style={{ fontSize: "20px !important", fontWeight: 600, color: '#008688' }}
                    >
                        [#{applicationNumber}]
                    </Typography>
                  </Box>
                  {fetchUserApplicationData && fetchUserApplicationData?.externalId && 
                    <CrmIdChip crmId={fetchUserApplicationData?.externalId} label="App Id:" />}
                  <Chip
                    label={applicationStatus}
                    className="card-contaner-status"
                  />
                  {/* <ConsentAuthorizationButton type="applicant" onClick={handleTriggerConsentAuthorization} /> */}
                  
                </Box>
              }
            </Box>

          {/* Submit Application Button */}
          {/*  */}
          {pageTypeSummary==="loansummary"  && (
            <Box sx={{ display: "flex", justifyContent: "flex-end",marginBottom:"-47px" }}>
              <PrimaryButtonSecond
                onClick={handleSubmitApplication}
                disabled={isSubmittinLoader}
                sx={{
                  minWidth: "200px",
                  py: 1.5,
                  fontSize: "16px",
                  fontWeight: 600,
                  opacity: isSubmittinLoader ? 0.6 : 1,
                }}
              >
                {isSubmittinLoader ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1, color: "inherit" }} />
                    Submitting...
                  </>
                ) : (
                  "Submit For Review"
                )}
              </PrimaryButtonSecond>
            </Box>
          )}

          {/* {!isXsOrSm && !partnerStartedJourney && pageTypeSummary !== "loansummary" && (
            <Box sx={{ display: "flex", justifyContent: "flex-end",marginBottom:"-47px" }}>
              <PrimaryButtonSecond
                onClick={handleContinue}
                disabled={isContinueLoading}
                sx={{
                  minWidth: "200px",
                  py: 1.5,
                  fontSize: "16px",
                  fontWeight: 600,
                  opacity: isContinueLoading ? 0.6 : 1,
                }}
              >
                {isContinueLoading ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1, color: "inherit" }} />
                      Loading.
                  </>
                ) : (
                  "Continue"
                )}
              </PrimaryButtonSecond>
            </Box>
          )} */}

          {/* {salesUserId && (
            <IconButton onClick={() => handleTabChange("connect")}>
              <img src={ChatIcon} alt="Chat" />
              Connect with sales
            </IconButton>
          )} */}
        </Box>
      )}

      {shouldShowSummaryTabs && triggerData?.toUser!==false && (
        <>
          <CustomTabBar
            tabs={visibleTabs}
            activeTabId={summaryPageActiveTab}
            pageTypeSummary={pageTypeSummary}
            onTabChange={handleTabChange}
          />
        </>
      )}

      {isApplicant && !isXsOrSm && shouldShowSubmitButton() && pageTypeSummary === "loansummary" &&
        submitReviewNotice}

      {/* Submit Application Button for Mobile */}
      {isXsOrSm && shouldShowSubmitButton() && pageTypeSummary === "loansummary" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            my: 2,
          }}
        >
          <PrimaryButtonSecond
            onClick={handleSubmitApplication}
            disabled={isSubmittingApplication}
            sx={{
              width: "100%",
              py: 1.5,
              fontSize: "16px",
              fontWeight: 600,
              opacity: isSubmittingApplication ? 0.6 : 1,
            }}
          >
            {isSubmittingApplication ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1, color: "inherit" }} />
                Submitting...
              </>
            ) : (
              "Submit For Review"
            )}
          </PrimaryButtonSecond>
          {submitReviewNotice}
        </Box>
      )}

      <Box mt={1}>
        {summaryPageActiveTab === "summary" &&  <Summary handleContinue={handleContinue} isContinueLoading={isContinueLoading} setCourseNameData={setCourseNameData} pageTypeSummary={pageTypeSummary} />}
        {/* {summaryPageActiveTab === "sanctionDetails" && <SanctionDetails />} */}
        {summaryPageActiveTab === "appDetails" && <ApplicationDetails pageTypeSummary={pageTypeSummary} />}
        {/* {summaryPageActiveTab === "processingFee" && <ProcessingFee />} */}
        {summaryPageActiveTab === "loanDocuments" && <LoanDocuments />}
        {summaryPageActiveTab === "disbursementRequest" && (
          <DisbursementRequest loading={tableLoading} />
        )}
        {!shouldHideChatForPwa && summaryPageActiveTab === "connect" && salesUserId && (
          <ConnectWithSales />
        )}
      </Box>

      {/* Chat Component */}
      {!shouldHideChatForPwa && isChatConnectOpen && (
        <>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 1000,
              width: "100%",
              height: "100%",
            }}
            onClick={handleChatConnectClose}
          />

          <Box
            ref={chatRef}
            sx={{
              zIndex: 1301,
              position: "fixed",
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              alignItems: "flex-end",
              left: { xs: 0, md: "auto" },
              right: { xs: 0, md: 32 },
              width: { xs: "100%", md: "auto" },
              maxWidth: { xs: "100%", md: "400px" },
              bottom: {
                xs: 0,
                md: 120,
              },
            }}
          >
            <ConnectChatComponent
              userName={userProfile?.name || ""}
              open={isChatConnectOpen}
              onClose={handleChatConnectClose}
            />
          </Box>
        </>
      )}

      {/* connect with sales floating button */}
      {!shouldHideChatForPwa && viewAccess && salesUserId && Object.keys(triggerData || {}).length === 0 && (
        <Box
          ref={connectButtonRef}
          sx={{
            position: "fixed",
            bottom: { xs: 16, md: 32 },
            right: { xs: 16, md: 32 },
            zIndex: 1300,
          }}
        >
          <ButtonBase
            // onClick={() => handleTabChange("connect")}
            onClick={handleChatConnectOpen}
            sx={{
              borderRadius: "50%",
              position: "relative",
              width: 96,
              height: 96,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: "#fecd3d",
                boxShadow: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2,
              }}
            >
              <Box
                component="img"
                src={ChatIcon}
                alt="Chat"
                sx={{
                  width: "80%",
                  height: "80%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </Box>

            <Box
              component="svg"
              viewBox="0 0 100 100"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: 1,
                overflow: "visible",
              }}
            >
              <path id="textCurve" d="M 8,50 A 42,42 0 0,0 92,50" fill="none" />

              <text
                fill="#333"
                fontSize="10"
                fontWeight="700"
                letterSpacing="0px"
                textAnchor="middle"
              >
                {/* startOffset="50%" keeps it centered at the bottom */}
                <textPath href="#textCurve" startOffset="50%">
                  Connect with sales
                </textPath>
              </text>
            </Box>
          </ButtonBase>
        </Box>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%", whiteSpace: "pre-line", }}
        >
          {/* {snackbar.message} */}
          <strong>{snackbar.severity==="success" ? "Submission Success" : "Submission Failed"}</strong>
          <ul style={{ margin: "0px 0 0 0", paddingLeft: "0px", listStyle: "none" }}>
            {snackbar.message.split("\n").map((message, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "6px",
              }}
            >
              <span style={{ flexShrink: 0, fontSize: "18px", fontWeight: "bold", lineHeight: 1 }}>•</span>
              <span>{message}</span>
            </li>
            ))}
          </ul>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ViewSummary;
